export default __webpack_public_path__ + "static/media/image-login-screen.5e28cf62.jpg";